<template>
  <!-- 二级菜单 -->
  <div
    class="smy__second-menu"
    :class="{ 'smy__second-menu-hide': !isVisibleSecondMenu }"
    :style="{ 'z-index': isVisibleSecondMenu ? '99' : '' }"
  >
    <div class="logo-text">
      <div class="logo"></div>
      <p>单小二到家</p>
    </div>
    <Menu
      ref="secondMenu"
      theme="light"
      style="width: 160px; height: 100%; overflow-x: hidden"
      class="menu-box"
      @on-select="onSelect"
      :open-names="openNames"
      :active-name="tag"
    >
      <Submenu
        :name="menu.id + ''"
        v-for="menu in secondMenuList[firstMenu]"
        :key="menu.id"
      >
        <template slot="title">
          <span class="title-text">
            <Icon
              :type="menu.icon"
              :size="menu.size ? menu.size : '16'"
              style="vertical-align: baseline"
            ></Icon>
            {{ menu.name }}
          </span>
        </template>
        <MenuItem
          v-for="(item, i) in thirdMenuList[menu.id]"
          :name="menu.id + '-' + item.id"
          :key="menu.id + '-' + item.id"
          style="padding-left: 35px"
        >
          <!-- {{item}} -->
          <!-- <span style="color: #80848f; font-size: 13px; margin-left: 5px"> -->
          <span class="menu-span">
            {{ item.name }}
            <Badge
              class-name="demo-badge-alone"
              v-if="allBadgeCount[item.routerName]"
              :count="allBadgeCount[item.routerName]"
            />
            <Icon
              type="locked"
              v-show="isDisabledFunc && item.meta && item.meta.isDisabled"
            ></Icon>
          </span>
        </MenuItem>
      </Submenu>
    </Menu>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('menu', [
      'isVisibleSecondMenu',
      'firstMenu',
      'firstMenuList',
      'secondMenuList',
      'thirdMenuList',
      'tag',
      'menuIsLoadingOver',
      'allBadgeCount',
    ]),
    ...mapState('user', ['user', 'isDisabledFunc']),
    // 获取应展开的二级菜单
    openNames() {
      if (this.menuIsLoadingOver) {
        let openNames = []
        if (this.secondMenuList[this.firstMenu]) {
          this.secondMenuList[this.firstMenu].forEach((val) => {
            openNames.push(val.id + '')
          })
        }
        return openNames
      }
    },
  },
  watch: {
    // 刷新二级菜单的展开状态
    openNames(val) {
      if (this.menuIsLoadingOver) {
        this.$nextTick(() => {
          let menu = this.$refs.secondMenu
          menu.updateOpened()
          menu.updateActiveName()
        })
      }
    },
    tag(val) {
      if (this.menuIsLoadingOver) {
        this.$nextTick(() => {
          let menu = this.$refs.secondMenu
          // menu.updateOpened()
          menu.updateActiveName()
        })
      }
    },
    menuIsLoadingOver(val) {
      if (val) this.$Spin.hide()
    },
  },
  methods: {
    ...mapMutations('menu', ['_secondMenu', '_allBadgeCount']),
    ...mapActions('menu', ['_AddTag']),
    onSelect(name) {
      this._AddTag(name)
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
@import '../assets/whole';

// 不显示滚轮
::-webkit-scrollbar {
  display: none;
}

.ivu-menu {
  position: inherit;
}

.smy__second-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  box-shadow: 2px 0 6px #ededed;
  transition: 0.5s;
  -webkit-transition: 0.5s;
  background: #33c09c;

  .logo-text {
    flex-shrink: 0;
    display: flex;
    height: 60px;
    width: 160px;
    color: @primary-color;
    // color: #fff;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    background: #fff;
    // box-shadow: 0 2px 6px #ededed;
    z-index: 999;
    .logo {
      width: 30px;
      height: 35px;
      background-image: url('../assets/img/logo.png');
      background-size: 100%;
      background-repeat: no-repeat;
      margin-right: 10px;
    }
  }

  .title-text {
    // color: #80848f;
  }
  // .demo-badge{
  //   width: 42px;
  //   height: 42px;
  //   background: @primary-color!important;
  //   border-radius: 6px;
  //   display: inline-block;
  // }
}
.menu-box {
  background: #33c09c;
  color: hsla(0, 0%, 100%, 0.7);
  .menu-span {
    color: hsla(0, 0%, 100%, 0.7);
  }
  .ivu-menu-item-active {
    color: #fff;
  }
  .ivu-menu-submenu-title:hover {
    background: #33c09c;
    color: #fff;
  }
  .ivu-menu {
    .ivu-menu-item {
      border-right: none;
    }
    .ivu-menu-item:hover {
      background: #33c09c;
      color: #fff;
      .menu-span {
        color: #fff;
      }
    }
    .ivu-menu-item-active {
      border-left: 2px solid #fff;
      border-right: none;
      color: #fff;
      .menu-span {
        color: #fff;
      }
    }
  }
}

.smy__second-menu-hide {
  width: 0px;
  opacity: 0;
}
</style>
<style media="screen">
.demo-badge-alone {
  background: #8cdfb5 !important;
  position: relative;
  top: -2px;
  transform: scale(0.8) !important;
}
</style>
<style lang="less">
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background: #3ccba6 !important;
}
.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: #fff !important;
}
.smy__box .ivu-menu-submenu-title:hover,
.smy__box .ivu-menu-item:hover {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/SecondMenu.vue